import { render, staticRenderFns } from "./currencyDisplay.vue?vue&type=template&id=2a594812&scoped=true&"
import script from "./currencyDisplay.vue?vue&type=script&lang=js&"
export * from "./currencyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a594812",
  null
  
)

export default component.exports